import Konva from "konva";
import { MiniKonvaStage, KonvaStage } from "frontend/konva-stage-types";
import { atom } from "jotai";
import { MutableRefObject, ReactNode, RefObject } from "react";
import { Transformer } from "konva/types/shapes/Transformer";
import { BoardMemberCache } from "shared/datamodel/schemas/board";
import { Team, TeamWithProjects } from "shared/datamodel/schemas/team";
import { SyncService } from "frontend/services/syncService";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";

/* DO NOT ABUSE THIS!! Don't put atoms here by default! Try to put them always in a distinct file.
Only if it really doesn't make sense and they are truly "general", put them here.
*****/

export const stageRefAtom = atom<RefObject<KonvaStage> | null>(null);

export const miniStageRefAtom = atom<RefObject<MiniKonvaStage> | null>(null);

export const layerRefAtom = atom<RefObject<Konva.Layer> | null>(null);

export const shouldFitWhenPlacingElementRefAtom = atom<MutableRefObject<boolean> | null>(null);

export const transformerRefAtom = atom<RefObject<Transformer> | null>(null);

export const syncServiceAtom = atom<SyncService<RW> | null>(null);

export const appLoadingAtom = atom<boolean>(false);

export const filesSignedUrlsAtom = atom<Record<string, string>>({});

export const cordAuthAtom = atom<string | null>(null);

export const errorMessageAtom = atom<ReactNode | null>(null);

export const isBannerNotificationOnAtom = atom<boolean>(false);

export const isUserDisconnectedAtom = atom<boolean>(false);

export enum HtmlDialogDisplay {
  None,
  InviteToAccount,
  InviteToBoard,
  EditSeats,
  ShowUpgradeModal,
  OpenTaskCard,
}

export const htmlDisplayAtom = atom(HtmlDialogDisplay.None);

export const authTokenAtom = atom<string | null>(null);

export const boardMemberCacheAtom = atom<BoardMemberCache>({});

export const teamsWithProjectsAtom = atom<TeamWithProjects[] | null>(null);

export const projectsParentAtom = atom<Record<string, Pick<Team, "documentId" | "name" | "permission" | "isOwner">>>(
  {}
);

export const showRestrictedModalAtom = atom<boolean>(false);

export const showAccountMembersAtom = atom<boolean>(false);
